// IMPORTANT! This file was copied from the original source code
// of the third party tool 'reakit v1.2.2'. Some changes were made to
// adhere to the styles made by the UX team
// Source code: https://github.com/ariakit/ariakit/blob/reakit%401.2.2/packages/reakit/src/Popover/PopoverArrow.tsx
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { createComponent } from 'reakit-system/createComponent';
import { createHook } from 'reakit-system/createHook';
import { useForkRef } from 'reakit-utils/useForkRef';
import { useBox } from 'reakit';
import { useTheme } from 'styled-components';
import { POPOVER_ARROW_KEYS } from './__keys';
// --- Ally --- start
export const getScale = (orientation, placement) => {
    if (placement === 'top' && orientation === 'left') {
        return 'scaleX(-1)';
    }
    if (placement === 'bottom' && orientation === 'left') {
        return 'scaleX(-1)';
    }
    if (placement === 'left' && orientation === 'left') {
        return 'scaleY(-1)';
    }
    if (placement === 'right' && orientation === 'left') {
        return 'scaleY(-1)';
    }
    return '';
};
// --- Ally --- end
export const usePopoverArrow = createHook({
    name: 'PopoverArrow',
    compose: useBox,
    keys: POPOVER_ARROW_KEYS,
    useOptions(_a) {
        var { size = 30 } = _a, options = __rest(_a, ["size"]);
        return Object.assign({ size }, options);
    },
    useProps(options, _a) {
        var { ref: htmlRef, style: htmlStyle } = _a, htmlProps = __rest(_a, ["ref", "style"]);
        const [placement] = options.placement.split('-');
        const transformMap = {
            top: 'rotateZ(180deg)',
            right: 'rotateZ(-90deg)',
            bottom: 'rotateZ(360deg)',
            left: 'rotateZ(90deg)',
        };
        const { colors } = useTheme();
        const { unstable_arrowStyles: arrowStyles } = options;
        const transform = transformMap[placement];
        const children = React.useMemo(() => (
        // --- Ally --- start
        React.createElement("svg", { width: "16px", height: "14px", viewBox: "0 0 16 14", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", style: { transform }, "aria-hidden": true },
            React.createElement("path", { d: "M3.41421356,1.41421356 L16,14 L16,14 L0,14 L0,2.82842712 C-1.3527075e-16,1.72385763 0.8954305,0.828427125 2,0.828427125 C2.53043298,0.828427125 3.03914081,1.03914081 3.41421356,1.41421356 Z", fill: colors.midnightblue }))
        // --- Ally --- end
        ), [transform]);
        // --- Ally --- start
        // The changes to width and height are a tricky way to correctly
        // center the new asymmetrical arrow. Since the arrow is 16px wide,
        // changing the width (or height when necessary) to 0px or 32px guarantees
        // that the edge vertical (or horizontal) edge of the asymmetrical arrow
        // will always be positioned directly in the middle of the trigger.
        // Then, it's just a matter or mirroring the arrow when necessary.
        // eslint-disable-next-line prefer-destructuring
        const orientation = htmlProps.orientation;
        let width = '16px';
        let height = '14px';
        if (options.placement === 'top') {
            width = options.orientation === 'left' ? '0px' : '32px';
        }
        if (options.placement === 'bottom') {
            width = options.orientation === 'left' ? '32px' : '0px';
        }
        if (options.placement === 'left') {
            height = options.orientation === 'left' ? '32px' : '0px';
            width = '14px';
        }
        if (options.placement === 'right') {
            height = options.orientation === 'left' ? '0px' : '32px';
            width = '14px';
        }
        // --- Ally --- end
        return Object.assign({ ref: useForkRef(options.unstable_arrowRef, htmlRef), style: Object.assign(Object.assign(Object.assign({}, arrowStyles), { 
                // --- Ally --- start
                // Arrow must be mirrored based on its position relative to
                // the popover body
                transform: `${arrowStyles === null || arrowStyles === void 0 ? void 0 : arrowStyles.transform} ${getScale(orientation, options.placement)}`, lineHeight: 0, 
                // Margin left and right fixes a gap between the arrow and body
                marginLeft: options.placement === 'left' ? '-1px' : '0', marginRight: options.placement === 'right' ? '-1px' : '0', 
                // Needed to be adjusted based on the proportions of the arrow
                // and the trick used to center the arrow
                height,
                width, 
                // --- Ally --- end
                fontSize: options.size, pointerEvents: 'none', [placement]: '100%' }), htmlStyle), children }, htmlProps);
    },
});
const PopoverArrow = createComponent({
    as: 'div',
    memo: true,
    useHook: usePopoverArrow,
});
export default PopoverArrow;
//# sourceMappingURL=DejargonatorArrow.js.map